// Configurarea paginii de înscriere self-service.
// Pagina NU este legată din meniuri publice: e accesibilă doar prin link direct sau QR.

export const TEMP_SIGNUP_PATH = '/inscriere-nautica-2026';

// Trebuie să corespundă cu TEMP_SIGNUP_KEY din backend/routes/signup.py
export const TEMP_SIGNUP_KEY = 'nautica-testare-2026';

export const tempSignupUrl = () => `${window.location.origin}${TEMP_SIGNUP_PATH}`;
